import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { isFunction } from '../../helpers/isFunction';
import { iconXMark } from '../../assets/icons';
import { PaperBase } from '../PaperBase';
import { sideSheetContentStyles } from './SideSheetContent.styles';
import { sideSheetContentTheme } from './SideSheetContent.stylex';
import { IconButton } from '../IconButton';
import { SvgIcon } from '../SvgIcon';
import { sideSheetVariantContentStyles } from './variants';
export const SideSheetContent = forwardRef(function SideSheetContent(props, forwardedRef) {
    const { styles, sx, variant = 'standard', onClose, children, anchor = 'left', headline, leadingActions, trailingActions, showCloseButton, closeIcon, bottomActions, divider, header, footer, ...other } = props;
    const variantStyles = sideSheetVariantContentStyles[variant];
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'SideSheetContent',
        styles: [sideSheetContentStyles, variantStyles, styles],
    });
    const hasHeader = !!header ||
        !!leadingActions ||
        !!trailingActions ||
        !!headline ||
        showCloseButton;
    return (_jsx(PaperBase, { ...other, sx: [
            sideSheetContentTheme,
            globalStyles,
            combineStyles('host', `host$${anchor}`, divider && `host$divider$${anchor}`),
            sx,
        ], ref: forwardedRef, children: _jsxs("div", { ...getStyles('inner'), children: [hasHeader ? (_jsxs("div", { ...getStyles('headerContainer'), children: [_jsxs("div", { ...getStyles('header', !!leadingActions && 'header$withLeadingActions'), children: [leadingActions ? (_jsx("div", { ...getStyles('actions'), children: leadingActions })) : null, headline ? (_jsx("div", { ...getStyles('headline'), children: headline })) : null, trailingActions || showCloseButton ? (_jsxs("div", { ...getStyles('actions'), children: [trailingActions, _jsx(IconButton, { icon: closeIcon ?? _jsx(SvgIcon, { icon: iconXMark }), onClick: onClose })] })) : null] }), header] })) : null, children ? (_jsx("div", { ...getStyles('content'), children: isFunction(children)
                        ? children({ close: (event) => onClose?.(event) })
                        : children })) : null, (footer ?? bottomActions) ? (_jsxs("div", { ...getStyles('footerContainer'), children: [_jsx("div", { ...getStyles('footer'), children: bottomActions ? (_jsx("div", { ...getStyles('actions'), children: isFunction(bottomActions)
                                    ? bottomActions({ close: (event) => onClose?.(event) })
                                    : bottomActions })) : null }), footer] })) : null] }) }));
});
